import styled from 'styled-components'

export const List = styled.div`
  max-width: 1024px;
  width: 100%;
  margin: 80px auto 120px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 80px;
  row-gap: 48px;
`
